import React, {Component} from "react";
import PropsTypes from 'prop-types'
import {_createNewWorker} from "../../../../../services/apis/WorkerServices"

class CreateNewWorker extends Component {
    state = {
        username: '',
        password: '',
        note: '',
        cookies: '',
        secretCode: ''
    }

    _handleSubmit = (e) => {
        e.preventDefault();
        const {username, password, note, cookies} = this.state;
        _createNewWorker({username, password, note, cookies})
            .then(result => {
                if (result.success) {
                    this.setState({
                        username: '',
                        password: '',
                        note: '',
                        cookies: '',
                        secretCode: ''
                    })
                    this.props.onRefreshPage()
                }

            })
    }

    _handleChangeTextForm = field => e => {
        const {value} = e.target;

        this.setState({
            [field]: value
        });
    }

    render() {
        const {username, password, note, cookies, secretCode} = this.state;
        return (
            <div className="CreateNewEvent col-md-4 col-12">
                <form onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={username}
                            placeholder='Username'
                            onChange={this._handleChangeTextForm('username')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={password}
                            placeholder='Password'
                            onChange={this._handleChangeTextForm('password')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={secretCode}
                            placeholder='Secret code'
                            onChange={this._handleChangeTextForm('secretCode')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={note}
                            placeholder='Note'
                            onChange={this._handleChangeTextForm('note')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            className='form-control'
                            value={cookies}
                            placeholder='Cookies'
                            onChange={this._handleChangeTextForm('cookies')}
                        />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" type='submit'>Create</button>
                    </div>
                </form>
            </div>
        );
    }
}


CreateNewWorker.propsTypes = {
    onRefreshPage: PropsTypes.func.isRequired,
}


export default CreateNewWorker;



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/CreateNewWorker.js